import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState, useEffect, useRef } from "react";
import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import InputMask from 'react-input-mask';
import { handleUnauthorized } from '../../../src/utils/apiHelper';
import { useNavigate, useParams } from 'react-router-dom';
import SuccessAlert from './../child/Alert/SuccessAlert';
import DengerAlert from './../child/Alert/DengerAlert';
import Loader from "./../child/Loder";

const ViewProfileLayer = () => {
    const [imagePreview, setImagePreview] = useState('assets/images/user-grid/user-grid-img13.png');
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
    const userRole = localStorage.getItem("user_role") === "super_admin" ? "Super Admin" : "Sub Admin";
    const [userName, setuserName] = useState("");
    const [userEmail, setuserEmail] = useState("");
    const [userPhone, setuserPhone] = useState(""); 
    const [userProfile, setProfilePicture] = useState("");
    const [Name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState(""); 
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [oldPassword, setOldPassword] = useState("");

    const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
    const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
    var imgchnage = 0;
    
  const navigate = useNavigate();

    const id = localStorage.getItem("admin_id");
    useEffect(() => {
        const fetchAdminData = async () => {
          const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminById/${id}`;
          setLoading(true);
          try {
          
            const authToken = localStorage.getItem("authToken");
            const response = await fetch(API_ENDPOINT, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            });
    
            if (!response.ok) throw new Error("Failed to fetch admin data");
    
            const data = await response.json();
            setuserName(data.result.name || "");
            setName(data.result.name || "");
            setImagePreview(data.result.profilePicture || "");// use for edit Profile section image preview
            setProfilePicture(data.result.profilePicture || ""); // use for view Profile section
            setPhone((data.result.dialCode || "") + (data.result.phone || ""));// use for Edit Profile
            setuserPhone((data.result.dialCode || "") + (data.result.phone || ""));// use for View Phone number 
            setuserEmail((data.result.email || ""));
            setPhone((data.result.dialCode || "") + (data.result.phone || ""));
            setImagePreview(data.result.profilePicture || 'assets/images/user-grid/user-grid-img13.png');
          } catch (err) {
          
            setLoading(false);
          } finally {
            setLoading(false);
          }
        };
    
        fetchAdminData();
      }, [id]); 
      

            // Toggle function for password field
            const togglePasswordVisibility = () => setPasswordVisible(prev => !prev);
            const toggleConfirmPasswordVisibility = () => setConfirmPasswordVisible(prev => !prev);
            const toggleOldPasswordVisibility = () => setOldPasswordVisible(prev => !prev);

    const s3Client = new S3Client({
        region: process.env.REACT_APP_AWS_REGION,
        credentials: {
          accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
          secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
        },
      });

    const uploadToS3 = async (file) => {
        if (!file) return null;
        const fileKey = `temp/${Date.now()}_${file.name}`;
        const params = {
            Bucket: process.env.REACT_APP_AWS_S3_BUCKET_NAME,
            Key: fileKey,
            Body: await file.arrayBuffer(),
            ContentType: file.type,
            ACL: "public-read",
        };
        try {
            const command = new PutObjectCommand(params);
            await s3Client.send(command);
            return `https://${process.env.REACT_APP_AWS_S3_BUCKET_NAME}.s3.${process.env.REACT_APP_AWS_REGION}.amazonaws.com/${fileKey}`;
        } catch (error) {
            console.error("S3 Upload Error:", error);
            throw new Error("Failed to upload file to S3.");
        }
    };


    const readURL = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = async (e) => {
                try {
                    const uploadedProfilePicture = await uploadToS3(file);
                    
                    setImagePreview(uploadedProfilePicture); // Set uploaded URL to state
                    imgchnage = 1;
                } catch (error) {
                    console.error("Error uploading image:", error);
                }
            };
            reader.readAsDataURL(file);
        }
    };
    
  const allowedMimeTypes = ["image/png", "image/jpeg"];
    const validateInputs = () => {
        const newErrors = {};
        if (!Name) newErrors.Name = "Full name is required";
        if(Name)
            {
              if (!/^[A-Za-z\s]+$/.test(Name))
              {
                newErrors.Name = "Full name must contain only alphabets";
              }
            }
        if (!phone) newErrors.phone = "Phone is required";
        if(imgchnage == 1)
        {
            if (imagePreview && !allowedMimeTypes.includes(imagePreview.type)) {
                newErrors.profilePicture = "Only PNG and JPG files are allowed.";
              }
        }
        const numericPhone = phone.replace(/\D/g, ""); 

        if (numericPhone.length !== 11) {
          newErrors.phone = "Enter a valid Phone Number";
        }
       
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
    const handleSubmit = async (event) => {
    
        event.preventDefault();
        if (!validateInputs()) return;
    
        setLoading(true);
        let uploadedProfilePicture = imagePreview;

       
      

        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/updateAdmin`;
        const authToken = localStorage.getItem("authToken");
      
        let phoneNumber;
        let countryCode = "";
        
        const pattern = /\(\d{3}\)/; // Checks if the number has (123) format
    
        if (pattern.test(phone)) {
          
            countryCode = phone.match(/^\+?\d+/)?.[0] || "";
        } else {
           
            countryCode = phone.match(/^\+?\d+/)?.[0] || "";
            const formattedNumber = phone.startsWith("+") ? phone.substring(countryCode.length) : phone;
            phoneNumber = formattedNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
        }
    
       
    
        phoneNumber = phone.replace(/\D/g, ""); // Remove all non-numeric characters
    
      
    
        if (phoneNumber.startsWith("+")) {
            let countryCodeMatch = phone.match(/^\+\d+/)?.[0]; // Extracts the country code
            if (countryCodeMatch) {
                phoneNumber = phoneNumber.replace(countryCodeMatch.replace(/\D/g, ""), ""); // Remove country code
            }
        }
        else {
            countryCode = phoneNumber.charAt(0); // First digit as country code
            phoneNumber = phoneNumber.substring(1); // Remove first digit from phone number
        }
    
      
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    
        try {
          const response = await fetch(API_ENDPOINT, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
              name: Name,
              profilePicture: uploadedProfilePicture,
              dialCode: '+'+countryCode,
                phone: phoneNumber,
              timeZone: timeZone,
            }),
          });
    
          if (response.status === 401) {
            handleUnauthorized(navigate);
            return;
          }
    
          const data = await response.json();
          
          if (response.ok) {
            localStorage.setItem("name", data.admin.name);
            localStorage.setItem("profile_picture",data.admin.profilePicture);
         
            setSuccessMessage("Your Profile as beedn Update Successfully");
            setTimeout(() => {
               // setLoading(false);
              setSuccessMessage("");
              window.location.reload();
            },1000);
           // window.location.reload();
          } else {
            setErrorMessage(data.message);
            setLoading(false);
          }
        } catch (error) {
            //setLoading(false);
            setErrorMessage(error.message);
            setTimeout(() => {
              setErrorMessage("");
            }, 3000);
          
        } finally {
          setLoading(false);
        }
      };
            // Validate inputs
    const validatechangeInputs = () => {
        const newErrors = {};
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

        if (!oldPassword) newErrors.oldPassword = "Old password is required";
        if (!newPassword) {
        newErrors.newPassword = "New password is required";
        } else if (!passwordRegex.test(newPassword)) {
        newErrors.newPassword = "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number";
        }
        if (!confirmPassword) newErrors.confirmPassword = "Confirm password is required";
        if (newPassword !== confirmPassword) newErrors.confirmPassword = "The new password and confirm password must match.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
      const changehandleSubmits = async (event) => {
       
        event.preventDefault();
        if (!validatechangeInputs()) return;
        const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/adminChangePassword`;
       
        const authToken = localStorage.getItem('authToken');
            
            setLoading(true);
        try {
           
          const response = await fetch(API_ENDPOINT, {
            method: "PUT",
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${authToken}`,
            },
            body: JSON.stringify({
              oldPassword:oldPassword,
              newPassword:newPassword,
              confirmPassword:confirmPassword
            }),
          });
    
          const data = await response.json();
          if (response.ok) {
            setSuccessMessage("Password changed successfully !! Redirecting...");
           
          
            setOldPasswordVisible("");
            setConfirmPasswordVisible("");
            setPasswordVisible("");
            localStorage.removeItem("authToken");
            localStorage.removeItem("admin_id");
            localStorage.removeItem("user_role");
            localStorage.removeItem("permissions");
            localStorage.removeItem("profile_picture");
            localStorage.removeItem("name");
            sessionStorage.clear(); // Also clear session storage (if used)
            setTimeout(() => {
                setLoading(false);
                setSuccessMessage("");
                navigate("/sign-in"); 
                window.location.reload();
              },1000);
            // Redirect after a small delay
            //window.location.reload(); // Ensure data is fully cleared
          } else {
            setErrorMessage(data.message || "Failed to change password");
            setTimeout(() => setErrorMessage(""),1000);
          }
        } catch (error) {
            setErrorMessage(error?.message || "Something went wrong");
            setTimeout(() => setErrorMessage(""),1000);
        } finally {
          setLoading(false);
        }
      };
      if (loading) {
        if (loading) return <Loader />;
      }
      return (
        <div className="row gy-4">
            
            <div className="col-lg-4">
            {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
            {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}
                <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
                    {/* <img
                        src={userProfile}
                        alt=""
                        className="w-100 object-fit-cover"
                    /> */}
                    <div className="pb-24 ms-16 mb-24 me-16 ">
                            <div className="text-center border border-top-0 border-start-0 border-end-0">
                                <img
                                    src={userProfile}
                                    alt=""
                                    className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                                />
                                <h6 className="mb-0 mt-16">{userName}</h6>
                                <span className="text-secondary-light mb-16">{userEmail}</span>
                            </div>
                        <div className="mt-24">
                            <h6 className="text-xl mb-16">Personal Info</h6>
                            <ul>
                                <li className=" align-items-center gap-1 mb-12">
                                    <span className="w-100 text-md fw-semibold text-primary-light">
                                        Full Name
                                    </span>
                                    <span className="w-100 text-secondary-light fw-medium">
                                         {userName}
                                    </span>
                                </li>
                                <li className="align-items-center gap-1 mb-12">
                                    <span className="w-100 text-md fw-semibold text-primary-light">
                                        {" "}
                                        Email
                                    </span>
                                    <span className="w-100 text-secondary-light fw-medium">
                                         {userEmail}
                                    </span>
                                </li>
                                <li className="align-items-center gap-1 mb-12">
                                    <span className="w-100 text-md fw-semibold text-primary-light">
                                        {" "}
                                        Phone Number
                                    </span>
                                    <span className="w-100 text-secondary-light fw-medium">
                                         {userPhone}
                                    </span>
                                </li>
                                <li className=" align-items-center gap-1 mb-12">
                                    <span className="w-100 text-md fw-semibold text-primary-light">
                                        {" "}
                                        Role
                                    </span>
                                    <span className="w-100 text-secondary-light fw-medium">
                                         {userRole}
                                    </span>
                                </li>
                               
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-8">
                <div className="card h-100">
                    <div className="card-body p-24">
                        <ul
                            className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                            id="pills-tab"
                            role="tablist"
                        >
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24 active"
                                    id="pills-edit-profile-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-edit-profile"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-edit-profile"
                                    aria-selected="true"
                                >
                                    Edit Profile
                                </button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button
                                    className="nav-link d-flex align-items-center px-24"
                                    id="pills-change-passwork-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-change-passwork"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-change-passwork"
                                    aria-selected="false"
                                    tabIndex={-1}
                                >
                                    Change Password
                                </button>
                            </li>
                            
                        </ul>
                        <div className="tab-content" id="pills-tabContent">
                            <div
                                className="tab-pane fade show active"
                                id="pills-edit-profile"
                                role="tabpanel"
                                aria-labelledby="pills-edit-profile-tab"
                                tabIndex={0}
                            >
                                <h6 className="text-md text-primary-light mb-16">Profile Image</h6>
                                <form action="#" onSubmit={handleSubmit}> 
                                {/* Upload Image Start */}
                                <div className="mb-24 mt-16">
                                    <div className="avatar-upload">
                                        <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                                            <input
                                                type="file"
                                                id="imageUpload"
                                                accept=".png, .jpg, .jpeg"
                                                hidden
                                                onChange={readURL}
                                              
                                                
                                            />
                                            <label
                                                htmlFor="imageUpload"
                                                className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-50 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                                            >
                                                <Icon icon="solar:camera-outline" className="icon"></Icon>
                                            </label>
                                        </div>
                                        <div className="avatar-preview">
                                            <div
                                                id="imagePreview"
                                                style={{
                                                    backgroundImage: `url(${imagePreview})`,
                                                    backgroundSize: 'cover',
                                                    backgroundPosition: 'center'
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {errors.profilePicture && <p className="text-danger mt-1">{errors.profilePicture}</p>}
                                </div>
                                {/* Upload Image End */}
                              
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="name"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                >
                                                    Full Name
                                                    <span className="text-danger-600">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control radius-8"
                                                    id="name"
                                                    placeholder="Enter Full Name" value={Name}
                                                    onChange={(e) => {
                                                        setName(e.target.value);
                                                        setErrors((prev) => ({ ...prev, Name: "" }));
                                                      }}
                                                      invalid={!!errors.Name}
                                                />
                                            </div>
                                            {errors.Name && <p className="text-danger mt-1">{errors.Name}</p>}
                                        </div>
 
                                        <div className="col-sm-6">
                                            <div className="mb-20">
                                                <label
                                                    htmlFor="number"
                                                    className="form-label fw-semibold text-primary-light text-sm mb-8"
                                                >
                                                    Phone
                                                </label>
                                                <InputMask mask="+9 (999) 999 9999" value={phone} onChange={(e) => setPhone(e.target.value)}>
                                                    {(inputProps) => <input {...inputProps} type="tel" placeholder="Phone"    className="form-control radius-8"/>}
                                                </InputMask>
                                               

                                               
                                            </div>
                                            {errors.phone && <p className="text-danger mt-1">{errors.phone}</p>}
                                            
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center gap-3"  style={{ float: "inline-end"}}>
                                        <button
                                           type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                        >
                                            Save
                                        </button>
                                    </div>
                                </form>
                            </div>
                            <div className="tab-pane fade" id="pills-change-passwork" role="tabpanel" aria-labelledby="pills-change-passwork-tab" tabIndex="0">
                            <form action="#" onSubmit={changehandleSubmits}> 

                            <div className="mb-20">
                                    <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Old Password <span className="text-danger-600">*</span>
                                    </label>
                                    <div className="position-relative">
                                        <input
                                            type={oldPasswordVisible ? "text" : "password"}
                                            className="form-control"
                                            id="old-password"
                                            placeholder="Enter old Password"
                                            maxLength="20"
                                            value={oldPassword}
                                            onChange={(e) => {
                                                        setOldPassword(e.target.value)
                                                        setErrors((prev) => ({ ...prev, oldPassword: "" }));
                                                      }}
                                            invalid={!!errors.oldPassword}
                                           
                                          
                                        />

                                        <span
                                            className={`toggle-password ${oldPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                            onClick={toggleOldPasswordVisibility}
                                        ></span>
                                    </div>
                                    {errors.oldPassword && <p className="text-danger mt-1">{errors.oldPassword}</p>}
                                </div>
                                <div className="mb-20">
                                    <label htmlFor="your-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        New Password <span className="text-danger-600">*</span>
                                    </label>
                                    <div className="position-relative">
                                            <input
                                        type={passwordVisible ? "text" : "password"}
                                        className="form-control"
                                        id="new-password"
                                        placeholder="Enter New Password"
                                        maxLength="20"
                                        value={newPassword}
                                         onChange={(e) => {
                                                        setNewPassword(e.target.value)
                                                        setErrors((prev) => ({ ...prev, newPassword: "" }));
                                                      }}
                                            invalid={!!errors.oldPassword}
                                        
                                    />
                                        <span
                                            className={`toggle-password ${passwordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                            onClick={togglePasswordVisibility}
                                        ></span>
                                    </div>
                                    {errors.newPassword && <p className="text-danger mt-1">{errors.newPassword}</p>}
                                </div>

                                <div className="mb-20">
                                    <label htmlFor="confirm-password" className="form-label fw-semibold text-primary-light text-sm mb-8">
                                        Confirm Password <span className="text-danger-600">*</span>
                                    </label>
                                    <div className="position-relative">
                                    <input
                                            type={confirmPasswordVisible ? "text" : "password"}
                                            className="form-control"
                                            id="confirm-password"
                                            placeholder="Enter Confirm Password"
                                            value={confirmPassword}
                                            maxLength="20"
                                             onChange={(e) => {
                                                        setConfirmPassword(e.target.value)
                                                        setErrors((prev) => ({ ...prev, confirmPassword: "" }));
                                                      }}
                                            invalid={!!errors.confirmPassword}
                                          
                                        />
                                        <span
                                            className={`toggle-password ${confirmPasswordVisible ? "ri-eye-off-line" : "ri-eye-line"} cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light`}
                                            onClick={toggleConfirmPasswordVisibility}
                                        ></span>
                                    </div>
                                    {errors.confirmPassword && <p className="text-danger mt-1">{errors.confirmPassword}</p>}
                                    
                                </div>
                                <div className="d-flex align-items-center justify-content-center gap-3" style={{ float: "inline-end"}}>
                                        <button
                                           type="submit"
                                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                                        >
                                            Save
                                        </button>
                                    </div>
                                 </form>
                            </div>
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default ViewProfileLayer;